import {Injectable} from '@angular/core';

@Injectable()
export class AlfaModel {
    public AgentID: any;
    public AgentPIN: any;
    public AgenttrxID: any;
    public AgentstoreID: any;
    public ProductID: any;
    public CustomerID: any;
    public PaymentPeriod: any;
    public Amount: any;
    public Charge: any;
    public Total: any;
    public AdminFee: any;
}
